import { formatDate } from 'src/utils/commonUtils';

export const getFormattedEnachDate = (enachCardDate: string) => {
  return `${formatDate(enachCardDate || '', { year: undefined })}, ${formatDate(
    enachCardDate || '',
    { day: undefined, month: undefined, year: 'numeric' }
  )}`;
};
